@if (templateData(); as data) {
  <div [class.limit-portrait-width-on-desktop]="data.limitPortraitWidthOnDesktop">
    <div
      [style.flex]="data.flex"
      [style.min-width]="data.minWidth"
      [style.max-width]="data.maxWidth"
      [class.ghost]="data.hasGhost"
      [class.image-loaded]="data.painted"
      [class.image-instant]="data.instant"
      [class.image-faded]="data.faded"
      [style.border-radius]="data.borderRadius"
      [class.ghostless-error]="!data.hasGhost && data.hasError"
    >
      <div [style.padding-top]="data.aspect" [style.width]="data.wrapperWidth">
        <!-- Show the Progress Spinner if suitable and if not loaded while providing the progress.
             Decorative load chrome: hidden from assistive tech — a per-image "loading…"
             progressbar is announcement noise, and the image's alt conveys it once painted.
             `[attr.tabindex]="null"` strips MatProgressSpinner's default `-1` so the hidden
             node isn't focusable either (avoids an aria-hidden-focus finding). -->
        @if (data.showProgress && !data.isLoaded) {
          <mat-progress-spinner
            class="progress-spinner"
            mode="determinate"
            [value]="data.progress"
            aria-hidden="true"
            [attr.tabindex]="null"
          />
        }
        <!-- If there is an error -->
        <!-- Decorative error chrome: hidden from assistive tech. The fallback
             glyph is a visual "image unavailable" placeholder, not the image's
             content (a broken image has no content to convey, and `role="img"`
             with no accessible name is itself an AXE failure). Same treatment as
             the load spinner above. -->
        @if (data.hasError) {
          <app-fa-icon class="ghost-icon" [config]="data.errorIcon" aria-hidden="true" />
        }
        <!-- If there is no error and the image has loaded. The image markup is
             shared between the linked and unlinked cases via #imageTemplate below. -->
        @if (!data.hasError && data.isLoaded && data.imageData) {
          @if (data.link) {
            <app-abstract-link [config]="data.link" [ariaLabel]="data.link.title">
              <ng-container [ngTemplateOutlet]="imageTemplate" />
            </app-abstract-link>
          } @else {
            <ng-container [ngTemplateOutlet]="imageTemplate" />
          }
        }
      </div>
    </div>
  </div>

  <ng-template #imageTemplate>
    <img
      [style.border-radius]="data.borderRadius"
      [attr.src]="data.imageData"
      [attr.alt]="data.alt !== undefined ? data.alt : null"
      [attr.role]="data.decorative ? 'presentation' : null"
      (load)="onImagePaint()"
      (animationend)="onFadeComplete()"
    />
  </ng-template>
}
